// src/components/user/TestSeries.jsx
import React, { useState } from "react";
import PrelimsTestSeries from "./PrelimsTestSeries";
import MainsTestSeries from "./MainsTestSeries";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../ui/tabs";
import { BookOpen, FileText } from "lucide-react";
import { motion } from "framer-motion";

const TestSeries = () => {
  const [tab, setTab] = useState("prelims");
const [examMode, setExamMode] = useState(false);

  return (
    <div className="p-6 max-w-6xl mx-auto">
      {/* Header Section */}
      {!examMode && (
<motion.div
  initial={{ opacity: 0, y: -20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6 }}
  className="text-center mb-8"
>
  
        <h1 className="text-4xl font-extrabold text-gray-900 dark:text-gray-100 mb-2">
          📚 Test Series
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-400">
          Challenge yourself with UPSC-style Prelims and Mains test series.  
          Track performance, review solutions, and improve steadily.
        </p>
      </motion.div>
      )}

      {/* Tabs Section */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="bg-white dark:bg-gray-800 shadow-xl rounded-2xl p-6"
      >
        <Tabs defaultValue="prelims" value={tab} onValueChange={setTab}>
          {!examMode && (
<TabsList className="grid w-full grid-cols-2 gap-4 mb-6">
            <TabsTrigger
              value="prelims"
              className={`flex items-center justify-center gap-2 rounded-xl px-4 py-3 text-lg font-semibold transition-all ${
                tab === "prelims"
                  ? "bg-blue-600 text-white shadow-md"
                  : "bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
              }`}
            >
              <BookOpen className="w-5 h-5" /> Prelims
            </TabsTrigger>

            <TabsTrigger
              value="mains"
              className={`flex items-center justify-center gap-2 rounded-xl px-4 py-3 text-lg font-semibold transition-all ${
                tab === "mains"
                  ? "bg-green-600 text-white shadow-md"
                  : "bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
              }`}
            >
              <FileText className="w-5 h-5" /> Mains
            </TabsTrigger>
          </TabsList>
          )}

          <TabsContent value="prelims">
  <PrelimsTestSeries
    onExamModeChange={setExamMode}
  />
</TabsContent>

          <TabsContent value="mains">
            <MainsTestSeries />
          </TabsContent>
        </Tabs>
      </motion.div>
    </div>
  );
};

export default TestSeries;
